const initCatalogStock = {
  catalogStocks: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  isFormLoading: false,
  isImportLoading: false,
};

export const catalogStockReducer = (state = initCatalogStock, action: any) => {
  if (action.type === "SET_CATALOG_STOCK") {
    return {
      ...state,
      catalogStocks: action.value,
    };
  }
  if (action.type === "SET_CATALOG_STOCK_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_CATALOG_STOCK_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_CATALOG_STOCK") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_IMPORT_LOADING") {
    return {
      ...state,
      isImportLoading: action.value,
    };
  }
  return state;
};
